import type { PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import { WebRouteTypes } from "consts/enpoints/web";
import { isFormChanged } from "util/forms";
import UnsavedChanges from "ui/layouts/UnsavedChanges";
import type { OnboardingFormProps } from "./types";
import { withDetectIncomplete } from "features/ecommerce/helpers";

const OnboardingForm = ({
    sx,
    isSubmitting,
    isValid,
    dirty,
    touched,
    isIncomplete,
    requestedChangeFields,
    handleSubmit,
    children,
    slotProps = {},
}: PropsWithChildren<OnboardingFormProps>) => (
    <UnsavedChanges
        checkUnsavedChanges={() => isFormChanged({
            dirty,
            touched
        })}
        subscriberKey={WebRouteTypes.Onboarding}
    >
        <Box
            sx={{
                display: 'grid',
                gap: 2,
                ...sx
            }}
            component='form'
            autoComplete='off'
            onSubmit={handleSubmit}
        >
            {children}
            <LoadingButton
                variant='contained'
                type='submit'
                size='medium'
                {...slotProps.submit}
                loading={isSubmitting}
                disabled={(
                    !withDetectIncomplete(isIncomplete, requestedChangeFields) ||
                    !isValid ||
                    !isFormChanged({
                        dirty,
                        touched
                    })
                )}
            >
                {slotProps.submit?.children || 'Complete'}
            </LoadingButton>
        </Box>
    </UnsavedChanges>
);

export default OnboardingForm;
